export default class Homepage {
    constructor(){
        this.init()
    }
    init(){
        Array.from(document.querySelectorAll('label.placeholder'))
            .map((l)=>l.parentElement.querySelector('select'))
            .forEach((s)=>this.selectPlaceholder(s));
    }
    selectPlaceholder(select){
        let placeholder = select.parentElement.querySelector('label.placeholder');
        if(select.options[select.selectedIndex].value === ''){
            placeholder.removeAttribute('hidden');
        } else {
            placeholder.setAttribute('hidden', '');
        }
    }
    joinEmailList(event, form){
        event.preventDefault();
        let email = form.querySelector('input[type="email"]');
        let error = form.querySelector('.signup-error');
        if(error) error.parentElement.removeChild(error);
        let xhr = new XMLHttpRequest();
        xhr.open('POST', '/api/join-email-list');
        xhr.onload = function () {
            if (xhr.status === 204) {
                let signupArea = form.parentElement;
                signupArea.innerHTML = '<p>Thank you, your email '+email.value+' has been added to our list</p>';
            } else {
                if(xhr.responseText) console.log(xhr.responseText);
                let newError = document.createElement('p');
                newError.classList.add('signup-error');
                newError.innerText = 'Something went wrong, sorry.';
                form.parentElement.appendChild(newError);
            }
        }.bind(this);
        xhr.send(new FormData(form));
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/Homepage.js